import * as mainTerms from '../mainTerms';
const campaign = mainTerms.Setting.campaign.default
export const SetCampaign = {
    currentCampaign: {
        error: {
            fail: '선택된 ' + campaign + '을 대상 '+ campaign +'으로 지정하는 과정에서 오류가 발생했습니다.',
        },
    },
    deleteCampaign : {
        success: '정상적으로 삭제되었습니다.',
        error: {
            fail: '정상적으로 삭제되지 못했습니다.\n다시 시도해주세요.',
        },
    },
    copyCampaign: {
        success: '정상적으로 복사되었습니다.',
        error: {
            fail: '정상적으로 복사되지 못했습니다.\n다시 시도해주세요.',
        }
    },
    changeStatus: {
        success: '정상적으로 변경되었습니다.',
        error: {
            fail: '정상적으로 변경되지 못했습니다.\n다시 시도해주세요.',
        }
    },
    saveWeight: {
        success: '내용이 반영되었습니다.',
        error: {
            fail: '정상적으로 반영되지 못했습니다.\n다시 시도해주세요.',
        }
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            notFound: '해당 ' + campaign + '이 존재하지 않습니다.',
            setCurrentCampaign: '해당 ' + campaign + '을 대상 '+ campaign +'으로 지정하는 과정에서 오류가 발생했습니다.',
        }
    },
    history: {
        error: {
            invalidCampaign: '구형 ' + campaign + '은 히스토리 조회를 하실 수 없습니다.',
        }
    }
};

export const EditCampaign = { 
    editing: {
        success: campaign + ' 수정에 성공했습니다.',
        error: {
            getResponse: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            fail: campaign + ' 수정에 실패했습니다.',
            duplicatedName: '중복된 ' + campaign + '명은 사용하실 수 없습니다.',
            duplicatedCustomID: '중복된 커스텀 ID는 사용하실 수 없습니다.',
            notFound: '해당 ' + campaign + '이 존재하지 않습니다.',
        },
    },
    new : {
        success: campaign + ' 생성에 성공했습니다.',
        error: {
            fail: campaign + ' 생성에 실패했습니다.',
            duplicatedName: '중복된 ' + campaign + '명은 사용하실 수 없습니다.',
            duplicatedCustomID: '중복된 커스텀 ID는 사용하실 수 없습니다.',
            setCurrentCampaign: { 
                title: '선택된 ' + campaign + ' 지정 에러',
                message: '선택된 ' + campaign + '을 대상 '+ campaign +'으로 지정하는 과정에서 오류가 발생했습니다.'
            },
            clearCurrentCampaign: { 
                title: '선택된 ' + campaign + ' 초기화 에러',
                message: '선택된 ' + campaign + '을 초기화하는 과정에서 오류가 발생했습니다.',
            }
        },
    },
    other: {
        confirm: {
            warnIsModified: '변경 중인 내용은 저장되지 않습니다.\n정말 취소하시겠습니까?',
        },
    },
}